import { LoadingPointTableDTO } from '../../../../Domain/DTO/LoadingPointTableDTO';
import { ZoneTableDTO } from '../../../../Domain/DTO/ZoneTableDTO';

export class CargoTransporterRouteRateHelperProps{
}

export const InitialCargoTransporterRouteRateHelperProps: CargoTransporterRouteRateHelperProps = <CargoTransporterRouteRateHelperProps>{ 
};